import { MessageSystem } from '@halo/ui-chat-react';
import { MsgItem } from '../../msg-parts';
import type { MsgGroupSendMsgAdminContentProps } from './msg-group-send-msg-admin-content';
import { MsgGroupSendMsgAdminContent } from './msg-group-send-msg-admin-content';

export interface MsgGroupSendMsgAdminProps extends MsgGroupSendMsgAdminContentProps {}

export const MsgGroupSendMsgAdmin = memo(function MsgGroupSendMsgAdmin({
  message,
}: MsgGroupSendMsgAdminProps) {
  return (
    <MsgItem message={message}>
      <MessageSystem>
        <MsgGroupSendMsgAdminContent message={message} />
      </MessageSystem>
    </MsgItem>
  );
});
